<template>
  <FitButton
    class="coupon-item-btn"
    :disabled="isBtnDisable"
    :class="stampClass"
    @click.native.stop="handleClick"
    v-if="isShowBtn"
    >{{ btnText }}</FitButton
  >
</template>
<script lang="ts">
import { getCouponBtnText } from './business';
import { CouponState } from '../../type';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { FitButton } from '@tencent/wphk-ui';
import { getLang } from '@tencent/wphk-components-common/utils/lang';

@Component({
  components: {
    FitButton,
  },
})
/**
 * 领券按钮
 */
export default class CouponItemBtn extends Vue {
  @Prop() public state!: CouponState;
  @Prop({ default: '' }) public text!: string;

  /**
   * 获取操作按钮可见状态
   * 可领、已领和未解锁状态展示
   */
  get isShowBtn() {
    return (
      this.state !== CouponState.Expired && this.state !== CouponState.Used
    );
  }

  get isBtnDisable() {
    return this.state === CouponState.Empty;
  }

  /**
   * 获取按钮样式
   */
  get stampClass() {
    const isEn = getLang() === 'en';
    return [`coupon-item-btn-${this.state}`, isEn ? 'coupon-item-btn-en' : ''];
  }

  /**
   * 获取按钮文案
   */
  get btnText() {
    return this.text || getCouponBtnText(this.state);
  }

  handleClick() {
    this.$emit('click');
  }
}
</script>
<style lang="less" scoped>
@import "../../less/main.less";
.coupon-item-btn {
  vertical-align: top;  // 为<FitButton>（实际为<a>）指定基准先，否则会出现高度问题（错位）

  background: #07c160;
  border-radius: 6 / @rem;
  min-width: 88 / @rem;
  text-align: center;
  font-family: "PingFang HK";
  font-style: normal;
  font-weight: 500;
  font-size: 28 / @rem;
  line-height: 28 / @rem;
  color: #ffffff;
  padding: 14 / @rem;
  display: inline-block;
  margin: 0;
  &-2 {
    background: #e6f9ef;
    color: #07c160;
  }
  &-3 {
    background: #f2f2f2;
    color: #b3b3b3;
  }
  &-6 {
    position: relative;
    min-height: 56 / @rem;
    width: 116 / @rem;
    &::after {
      content: "";
      position: absolute;
      z-index: 3;
      width: 28 / @rem;
      height: 30 / @rem;
      background-image: url(./assets/btn-lock.png);
      background-repeat: no-repeat;
      background-size: 100%;
      left: 50%;
      top: 50%;
      margin-top: -15 / @rem;
      margin-left: -14 / @rem;
    }
  }
}
.coupon-item-btn-en {
  font-size: 26 / @rem;
  line-height: 26 / @rem;
}
</style>
